/**
 * @module auth.service
 */
import { DialVerseApi } from '../app/api'
import AppConfig from '../config'

const AuthService = DialVerseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Basic authentication routes
    login: builder.mutation({
      query: (credentials) => ({
        url: AppConfig.getUrl('/auth/login'),
        method: 'POST',
        body: credentials,
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: AppConfig.getUrl('/auth/logout'),
        method: 'POST',
      }),
    }),
    verify: builder.mutation({
      query: (token) => ({
        url: AppConfig.getUrl('/auth/verify'),
        method: 'POST',
        body: { token },
      }),
    }),

    // Protected routes
    getCurrentUser: builder.mutation({
      query: () => ({
        url: AppConfig.getUrl('/auth/me'),
        method: 'GET',
      }),
    }),
    updatePassword: builder.mutation({
      query: (passwordData) => ({
        url: AppConfig.getUrl('/auth/me/password'),
        method: 'PATCH',
        body: passwordData,
      }),
    }),

    // Admin-only routes
    listUsers: builder.mutation({
      query: (params = {}) => ({
        url: AppConfig.getUrl('/auth/users'),
        method: 'GET',
        params,
      }),
    }),
    getUserById: builder.mutation({
      query: (userId) => ({
        url: AppConfig.getUrl(`/auth/users/${userId}`),
        method: 'GET',
      }),
    }),

    // Staff and admin routes
    updateUserStatus: builder.mutation({
      query: ({ userId, status }) => ({
        url: AppConfig.getUrl(`/auth/users/${userId}/status`),
        method: 'PATCH',
        body: { status },
      }),
    }),
    updateUserRole: builder.mutation({
      query: ({ userId, role }) => ({
        url: AppConfig.getUrl(`/auth/users/${userId}/role`),
        method: 'PATCH',
        body: { role },
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useLoginMutation,
  useLogoutMutation,
  useVerifyMutation,
  useGetCurrentUserMutation,
  useUpdatePasswordMutation,
  useListUsersMutation,
  useGetUserByIdMutation,
  useUpdateUserStatusMutation,
  useUpdateUserRoleMutation,
} = AuthService
